/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menu_Quit_Current_Run_BodyInputs */

const bn_menu_quit_current_run_body = /** @type {(inputs: Menu_Quit_Current_Run_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`মূল মেনুতে ফিরবেন? আপনার বর্তমান রান অগ্রগতি হারিয়ে যাবে।`)
};

const de_menu_quit_current_run_body = /** @type {(inputs: Menu_Quit_Current_Run_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurück zum Hauptmenü? Ihr aktueller Lauffortschritt geht verloren.`)
};

const el_menu_quit_current_run_body = /** @type {(inputs: Menu_Quit_Current_Run_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Επιστροφή στο κύριο μενού; Η τρέχουσα πρόοδός σας θα χαθεί.`)
};

const en_menu_quit_current_run_body = /** @type {(inputs: Menu_Quit_Current_Run_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Return to the main menu? Your current run progress will be lost.`)
};

const es_menu_quit_current_run_body = /** @type {(inputs: Menu_Quit_Current_Run_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Volver al menú principal? Se perderá el progreso de su ejecución actual.`)
};

const fr_menu_quit_current_run_body = /** @type {(inputs: Menu_Quit_Current_Run_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revenir au menu principal ? La progression de la partie en cours sera perdue.`)
};

const hi_menu_quit_current_run_body = /** @type {(inputs: Menu_Quit_Current_Run_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मुख्य मेनू पर लौटें? आपकी वर्तमान चल रही प्रगति नष्ट हो जाएगी.`)
};

const hu_menu_quit_current_run_body = /** @type {(inputs: Menu_Quit_Current_Run_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vissza a főmenübe? A jelenlegi futási folyamatod elveszik.`)
};

const id_menu_quit_current_run_body = /** @type {(inputs: Menu_Quit_Current_Run_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kembali ke menu utama? Kemajuan lari Anda saat ini akan hilang.`)
};

const it_menu_quit_current_run_body = /** @type {(inputs: Menu_Quit_Current_Run_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ritornare al menu principale? I progressi della corsa corrente andranno persi.`)
};

const ja_menu_quit_current_run_body = /** @type {(inputs: Menu_Quit_Current_Run_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メインメニューに戻りますか?現在の実行の進行状況は失われます。`)
};

const ko_menu_quit_current_run_body = /** @type {(inputs: Menu_Quit_Current_Run_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`기본 메뉴로 돌아가시겠습니까? 현재 실행 진행 상황이 손실됩니다.`)
};

const nl_menu_quit_current_run_body = /** @type {(inputs: Menu_Quit_Current_Run_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terug naar het hoofdmenu? Je huidige hardloopvoortgang gaat verloren.`)
};

const pl_menu_quit_current_run_body = /** @type {(inputs: Menu_Quit_Current_Run_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powrót do menu głównego? Bieżący postęp biegu zostanie utracony.`)
};

const pt_menu_quit_current_run_body = /** @type {(inputs: Menu_Quit_Current_Run_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voltar ao menu principal? O progresso da sua corrida atual será perdido.`)
};

const ru_menu_quit_current_run_body = /** @type {(inputs: Menu_Quit_Current_Run_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вернуться в главное меню? Ваш текущий прогресс бега будет потерян.`)
};

const sv_menu_quit_current_run_body = /** @type {(inputs: Menu_Quit_Current_Run_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gå tillbaka till huvudmenyn? Din nuvarande körning kommer att gå förlorad.`)
};

const tr_menu_quit_current_run_body = /** @type {(inputs: Menu_Quit_Current_Run_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ana menüye dönülsün mü? Mevcut koşu ilerlemeniz kaybolacak.`)
};

const uk_menu_quit_current_run_body = /** @type {(inputs: Menu_Quit_Current_Run_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Повернутися до головного меню? Ваш поточний прогрес у бігу буде втрачено.`)
};

const vi_menu_quit_current_run_body = /** @type {(inputs: Menu_Quit_Current_Run_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quay lại menu chính? Tiến trình chạy hiện tại của bạn sẽ bị mất.`)
};

const zh_menu_quit_current_run_body = /** @type {(inputs: Menu_Quit_Current_Run_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`返回主菜单？您当前的跑步进度将会丢失。`)
};

const zh_hant_menu_quit_current_run_body = /** @type {(inputs: Menu_Quit_Current_Run_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`返回主選單？您目前的跑步進度將會遺失。`)
};

/**
* | output |
* | --- |
* | "Return to the main menu? Your current run progress will be lost." |
*
* @param {Menu_Quit_Current_Run_BodyInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const menu_quit_current_run_body = /** @type {((inputs?: Menu_Quit_Current_Run_BodyInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menu_Quit_Current_Run_BodyInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_menu_quit_current_run_body(inputs)
	if (locale === "de") return de_menu_quit_current_run_body(inputs)
	if (locale === "el") return el_menu_quit_current_run_body(inputs)
	if (locale === "en") return en_menu_quit_current_run_body(inputs)
	if (locale === "es") return es_menu_quit_current_run_body(inputs)
	if (locale === "fr") return fr_menu_quit_current_run_body(inputs)
	if (locale === "hi") return hi_menu_quit_current_run_body(inputs)
	if (locale === "hu") return hu_menu_quit_current_run_body(inputs)
	if (locale === "id") return id_menu_quit_current_run_body(inputs)
	if (locale === "it") return it_menu_quit_current_run_body(inputs)
	if (locale === "ja") return ja_menu_quit_current_run_body(inputs)
	if (locale === "ko") return ko_menu_quit_current_run_body(inputs)
	if (locale === "nl") return nl_menu_quit_current_run_body(inputs)
	if (locale === "pl") return pl_menu_quit_current_run_body(inputs)
	if (locale === "pt") return pt_menu_quit_current_run_body(inputs)
	if (locale === "ru") return ru_menu_quit_current_run_body(inputs)
	if (locale === "sv") return sv_menu_quit_current_run_body(inputs)
	if (locale === "tr") return tr_menu_quit_current_run_body(inputs)
	if (locale === "uk") return uk_menu_quit_current_run_body(inputs)
	if (locale === "vi") return vi_menu_quit_current_run_body(inputs)
	if (locale === "zh") return zh_menu_quit_current_run_body(inputs)
	return zh_hant_menu_quit_current_run_body(inputs)
});